import React, { createContext, useContext, useState } from 'react';
import { CgSpinner } from 'react-icons/cg';
import { FaGear } from 'react-icons/fa6';

const LoaderContext = createContext(undefined);

let setLoaderGlobal = () => { };

export const LoaderProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    setLoaderGlobal = setLoading;

    return (
        <LoaderContext.Provider value={{ setLoader: setLoading }}>
            {children}
            {loading && (
                <div className="fixed inset-0 bg-white/50 flex items-center flex-col justify-center z-50">
                    <CgSpinner size={100} color='#462A71' className="text-primary animation-spinner" />
                </div>
            )}
        </LoaderContext.Provider>
    );
};

export const useLoader = () => {
    const context = useContext(LoaderContext);
    if (!context) throw new Error('useLoader deve ser usado dentro de LoaderProvider');
    return context;
};

export const setGlobalLoader = (state) => {
    setLoaderGlobal(state);
};